import React from 'react'

import { Box, Text, Tooltip } from 'components'

import { SocketEvents } from 'socket'
import { LeadOwnerChangedData, QuotationChangedStatus } from 'services/types/notification'
import { LeadChangedData, LeadProcessChangedData, Notification } from 'types/global'

import LeadNameUpdate from './LeadNameUpdate'
import LeadProcessStageUpdate from './LeadProcessStageUpdate'
import LeadStatusUpdate from './LeadStatusUpdate'
import LeadProcessUpdate from './LeadProcessUpdate'
import { MarkReadRadio, NotificationItemWrapper } from './styles'
import LeadOwnerUpdate from './LeadOwnerUpdate'
import QuotationApproval from './QuotationApproval'
import { getLeadRoute } from 'utils/url'
import { useReusableTab } from 'hooks/use-reusable-lead-tab'

export const SUPPORTED_NOTIFICATION_TYPES = [
  SocketEvents.LEAD_NAME_UPDATE,
  SocketEvents.LEAD_OWNER_UPDATE,
  SocketEvents.LEAD_PROCESS_UPDATE,
  SocketEvents.LEAD_STATUS_UPDATE,
  SocketEvents.WORKFLOW_PROCESS_STAGE_ADD,
  SocketEvents.WORKFLOW_PROCESS_STAGE_DELETE,
  SocketEvents.QUOTATION_STATUS_UPDATE,
]

type Props = Notification & {
  index: number
  onReadStatusClick?: (index: number, status: boolean) => void
}

const NotificationItem: React.FC<Props> = ({ index, onReadStatusClick, ...props }) => {
  const { openInReusableTab } = useReusableTab()

  const getBody = () => {
    switch (props.notificationType) {
      case SocketEvents.QUOTATION_STATUS_UPDATE:
        return <QuotationApproval {...props} data={props.data as QuotationChangedStatus} />
      case SocketEvents.LEAD_NAME_UPDATE:
        return <LeadNameUpdate {...props} data={props.data as LeadChangedData} />
      case SocketEvents.LEAD_OWNER_UPDATE:
        return <LeadOwnerUpdate {...props} data={props.data as LeadOwnerChangedData} />
      case SocketEvents.LEAD_PROCESS_UPDATE:
        return <LeadProcessUpdate {...props} data={props.data as LeadChangedData} />
      case SocketEvents.LEAD_STATUS_UPDATE:
        return <LeadStatusUpdate {...props} data={props.data as LeadChangedData} />
      case SocketEvents.WORKFLOW_PROCESS_STAGE_ADD:
      case SocketEvents.WORKFLOW_PROCESS_STAGE_DELETE:
        return <LeadProcessStageUpdate {...props} data={props.data as LeadProcessChangedData} />
      default:
    }
  }

  if (!SUPPORTED_NOTIFICATION_TYPES.includes(props.notificationType)) {
    return <Text>notification_unsupported</Text>
  }

  const handleClick = (data: Notification) => {
    if (!data.leadId) return

    if (data.data?.quotation_id) {
      const leadUrl = `${getLeadRoute({
        leadId: data.leadId,
      })}?window=opportunities-tab&window_type=quotation&quotation_id=${data.data.quotation_id}`
      openInReusableTab(leadUrl)
      return
    }

    openInReusableTab(getLeadRoute({ leadId: data.leadId }))
  }

  return (
    <>
      <NotificationItemWrapper {...props}>
        <Box display="flex" width="100%" alignItems="center">
          <Tooltip title={props.isRead ? 'Mark as unread' : 'Mark as read'} position="left" textTransform="none">
            <MarkReadRadio {...props} onClick={() => onReadStatusClick && onReadStatusClick(index, props.isRead)} />
          </Tooltip>
          <Box cursor={props.leadId ? 'pointer' : undefined} onClick={() => handleClick(props)}>
            {getBody()}
          </Box>
        </Box>
      </NotificationItemWrapper>
    </>
  )
}

export default NotificationItem
